module.exports = __webpack_public_path__ + "img/bgpic3.61348880.png";